<div *ngIf="ttToolbar.enabled" class="gantt-toolbar" role="toolbar">
    <tt-gantt-button *ngIf="ttToolbar.columns" data-action="columns" ttTooltipText="columns" ttIcon="fal fa-columns" [ttDisabled]="busy" (ttClick)="toggleColumns($event)"></tt-gantt-button>
    <tt-gantt-button
        *ngIf="ttToolbar.reload"
        data-action="reload"
        ttTooltipText="reload_data"
        ttIcon="fal fa-sync-alt"
        [ttDisabled]="busy"
        [ttLoading]="ttLoading"
        (ttClick)="ttReload.emit()"
    ></tt-gantt-button>
    <tt-gantt-button
        *ngIf="ttToolbar.save && !ttAutoSave"
        data-action="save"
        ttText="save"
        ttIcon="fal fa-save"
        [ttDisabled]="busy || !ttHasChanges"
        [ttLoading]="ttSaving"
        (ttClick)="ttSave.emit()"
    ></tt-gantt-button>
    <tt-gantt-toggle
        *ngIf="ttToolbar.headers"
        data-action="field-names"
        ttIcon="fal fa-font-case"
        ttTooltipText="toggle_field_name"
        [ttModel]="ttFieldNames"
        [ttDisabled]="busy"
        (ttModelChange)="ttFieldNamesChange.emit($event)"
    ></tt-gantt-toggle>
    <tt-gantt-toggle
        *ngIf="ttToolbar.planningDirection"
        data-action="planning-direction"
        [ttText]="ttBackwardPlanning ? labels.backwardPlanning : labels.forwardPlanning"
        [ttTooltipText]="ttBackwardPlanning ? labels.backwardPlanning : labels.forwardPlanning"
        [ttTranslateText]="false"
        [ttTranslateTooltipText]="false"
        [ttIcon]="ttBackwardPlanning ? 'fal fa-arrow-left' : 'fal fa-arrow-right'"
        [ttModel]="ttBackwardPlanning"
        [ttDisabled]="busy"
        (ttModelChange)="ttBackwardPlanningChange.emit($event)"
    ></tt-gantt-toggle>
    <tt-gantt-toggle
        *ngIf="ttToolbar.criticalPath"
        data-action="critical-path"
        ttTooltipText="critical_path"
        ttIcon="fal fa-project-diagram"
        [ttModel]="ttCriticalPath"
        [ttDisabled]="busy"
        (ttModelChange)="ttCriticalPathChange.emit($event)"
    ></tt-gantt-toggle>
    <tt-gantt-toggle
        *ngIf="ttToolbar.resourceGraph"
        data-action="resource-graph"
        ttTooltipText="resource_graph"
        ttIcon="fal fa-chart-bar"
        [ttModel]="ttResourceGraph"
        [ttDisabled]="busy"
        (ttModelChange)="ttResourceGraphChange.emit($event)"
    ></tt-gantt-toggle>
</div>

<ng-template #columnsTemplate>
    <section class="gantt-columns" role="dialog" aria-modal="false" [id]="columnCheckboxPrefix + 'panel'" [attr.aria-labelledby]="columnCheckboxPrefix + 'title'">
        <header class="gantt-columns__header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container" (cdkDragEnded)="constrainColumns($event.source)">
            <span class="gantt-columns__title" cdkDragHandle [id]="columnCheckboxPrefix + 'title'">{{ labels.chooseColumns }}</span>
            <button type="button" class="gantt-columns__close" data-action="close-columns" [attr.aria-label]="labels.close" [title]="labels.close" (click)="closeColumns()">
                <span class="fal fa-times" aria-hidden="true"></span>
            </button>
        </header>
        <div *ngIf="ttResourceColumns.length" class="gantt-columns__areas" role="group" [attr.aria-label]="labels.chooseColumns">
            <button type="button" data-column-area="tasks" [attr.aria-pressed]="columnArea === 'tasks'" (click)="selectColumnArea('tasks')">{{ labels.tasks }}</button>
            <button type="button" data-column-area="resources" [attr.aria-pressed]="columnArea === 'resources'" (click)="selectColumnArea('resources')">{{ labels.resources }}</button>
        </div>
        <div class="gantt-columns__search-row">
            <input
                #selectAll
                type="checkbox"
                class="gantt-column-item__checkbox"
                data-action="select-all-columns"
                [attr.aria-label]="labels.selectAll"
                [title]="labels.selectAll"
                [checked]="allFilteredVisible"
                [indeterminate]="someFilteredVisible"
                [disabled]="busy || filteredColumns.length === 0"
                (change)="toggleAll(selectAll.checked)"
            />
            <label class="gantt-columns__search">
                <span class="fal fa-search" aria-hidden="true"></span>
                <input #searchInput type="search" [attr.aria-label]="labels.search" [placeholder]="labels.search" [value]="columnSearch" (input)="columnSearch = searchInput.value" />
            </label>
        </div>
        <ul class="gantt-columns__ul" cdkDropList [cdkDropListData]="filteredColumns" [cdkDropListDisabled]="busy" (cdkDropListDropped)="drop($event)">
            <li class="gantt-columns__item" *ngFor="let column of filteredColumns; index as index; trackBy: key" cdkDrag [cdkDragDisabled]="busy" [attr.data-property-key]="key(index, column)">
                <input
                    #visibilityCheckbox
                    type="checkbox"
                    class="gantt-column-item__checkbox"
                    [id]="columnCheckboxPrefix + index"
                    [checked]="isVisible(column)"
                    [disabled]="busy || isLastVisible(column)"
                    (change)="toggle(column, visibilityCheckbox.checked)"
                />
                <button
                    type="button"
                    cdkDragHandle
                    class="gantt-column-handle"
                    [disabled]="busy"
                    [attr.aria-label]="labels.reorder + ': ' + columnLabel(column)"
                    [title]="labels.reorder + ': ' + columnLabel(column)"
                >
                    <span class="fas fa-grip-vertical" aria-hidden="true"></span>
                </button>
                <label [for]="columnCheckboxPrefix + index" [title]="columnLabel(column)"
                    ><span>{{ columnLabel(column) }}</span></label
                >
                <button
                    type="button"
                    class="gantt-column-move"
                    data-action="move-up"
                    [disabled]="busy || index === 0"
                    [attr.aria-label]="labels.moveUp + ': ' + columnLabel(column)"
                    [title]="labels.moveUp + ': ' + columnLabel(column)"
                    (click)="moveFiltered(index, index - 1)"
                >
                    <span class="fal fa-arrow-up" aria-hidden="true"></span>
                </button>
                <button
                    type="button"
                    class="gantt-column-move"
                    data-action="move-down"
                    [disabled]="busy || index === filteredColumns.length - 1"
                    [attr.aria-label]="labels.moveDown + ': ' + columnLabel(column)"
                    [title]="labels.moveDown + ': ' + columnLabel(column)"
                    (click)="moveFiltered(index, index + 1)"
                >
                    <span class="fal fa-arrow-down" aria-hidden="true"></span>
                </button>
            </li>
            <li *ngIf="filteredColumns.length === 0" class="gantt-columns__empty">{{ labels.noColumns }}</li>
        </ul>
        <footer class="gantt-columns__footer">
            <button type="button" data-action="reset-columns" [disabled]="busy" (click)="resetColumns()">{{ labels.reset }}</button>
        </footer>
    </section>
</ng-template>
